import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useUiLayoutPreferences } from '../contexts/UiLayoutPreferencesContext';
import { Switch } from './ui';
import { cn } from '../lib/utils';

/**
 * Sidebar layout toggles — groups, search, favorites (saved per user).
 */
const UiSidebarLayoutToggles = ({ className }) => {
  const { theme } = useTheme();
  const {
    showSidebarGroups,
    showSidebarSearch,
    showSidebarFavorites,
    setShowSidebarGroups,
    setShowSidebarSearch,
    setShowSidebarFavorites,
  } = useUiLayoutPreferences();

  const rows = [
    {
      id: 'sidebar-groups',
      label: 'Ομάδες sidebar',
      description: 'Τίτλοι ενοτήτων (π.χ. QMS, Admin) στο μενού',
      checked: showSidebarGroups,
      onChange: setShowSidebarGroups,
    },
    {
      id: 'sidebar-search',
      label: 'Αναζήτηση μενού',
      description: 'Πεδίο αναζήτησης στο sidebar',
      checked: showSidebarSearch,
      onChange: setShowSidebarSearch,
    },
    {
      id: 'sidebar-favorites',
      label: 'Αγαπημένα',
      description: 'Ενότητα και καρφίτσωμα αγαπημένων συνδέσμων',
      checked: showSidebarFavorites,
      onChange: setShowSidebarFavorites,
    },
  ];

  return (
    <div className={cn('space-y-3', className)}>
      <p className={cn('text-[11px] leading-snug px-1', theme.text.muted)}>
        Sidebar — αποθηκεύεται στον λογαριασμό σας
      </p>
      {rows.map((row) => (
        <Switch
          key={row.id}
          variant="with-description"
          size="sm"
          label={row.label}
          description={row.description}
          checked={row.checked}
          onChange={row.onChange}
          className="w-full"
        />
      ))}
    </div>
  );
};

export default UiSidebarLayoutToggles;
